(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5444],{

/***/ 4818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconBathroom = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 24 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M4.154 5.54V1.885a1.385 1.385 0 1 1 2.77 0v.482M17.538 14.5v-1.866M6.461 14.5v-1.866M0 5.634h24",
  stroke: "currentColor",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "m22.468 5.54-2.431 5.593a2.494 2.494 0 0 1-2.288 1.5H6.251c-.993 0-1.892-.589-2.288-1.5L1.533 5.54",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconBathroom);

/***/ }),

/***/ 31381:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconCopy = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 11 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M9.665.667H3.443C3.2.667 3 .867 3 1.111v2.222H.776c-.244 0-.444.2-.444.445v7.111c0 .245.2.445.444.445H7c.244 0 .444-.2.444-.445V8.667h2.222c.244 0 .444-.2.444-.444V1.111c0-.244-.2-.444-.444-.444Zm-.444 7.11H7.443V3.779c0-.244-.2-.444-.445-.444h-3.11V1.556H9.22l.001 6.222Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconCopy);

/***/ }),

/***/ 95275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconEmail = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.35.667A1.725 1.725 0 0 0 .678 2.256L.668 9.61a1.73 1.73 0 0 0 1.724 1.724h11.213c.947 0 1.729-.778 1.729-1.724l-.005-7.338A1.733 1.733 0 0 0 13.605.667H2.35Zm12.317 2.469V9.61c0 .583-.477 1.057-1.062 1.057H2.392A1.057 1.057 0 0 1 1.335 9.61V3.147l5.687 5.682a1.413 1.413 0 0 0 1.948 0l5.697-5.693Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconEmail);

/***/ }),

/***/ 30967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconFacebook = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 8 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M4.873 16.107H1.646V8.303H.03V5.612h1.615V3.997c0-2.194.91-3.499 3.497-3.499h2.155v2.69H5.95c-1.007 0-1.074.376-1.074 1.077l-.004 1.347h2.441l-.286 2.69H4.873v7.805Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconFacebook);

/***/ }),

/***/ 89796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconLinkedin = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M3.266 12.257H.733V4.632h2.533v7.627-.002ZM2.001 3.59h-.018C1.132 3.59.582 3.004.582 2.27c0-.732.566-1.318 1.434-1.318.867 0 1.402.57 1.417 1.318 0 .733-.55 1.319-1.434 1.319h.002Zm10.407 8.667H9.873v-4.08c0-1.026-.367-1.725-1.284-1.725-.7 0-1.117.472-1.3.927-.068.163-.084.39-.084.618v4.26H4.67s.033-6.911 0-7.627h2.535v1.081c.336-.518.938-1.259 2.284-1.259 1.668 0 2.919 1.09 2.919 3.432v4.373Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconLinkedin);

/***/ }),

/***/ 34410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPinterest = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  viewBox: "0 0 14 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M7.424 0C2.489 0 0 3.719 0 6.819c0 1.877.677 3.548 2.127 4.17.238.103.451.004.521-.273.048-.192.16-.675.212-.877.07-.274.043-.37-.149-.608-.418-.52-.685-1.19-.685-2.14 0-2.759 1.964-5.228 5.114-5.228 2.79 0 4.321 1.791 4.321 4.182 0 3.148-1.325 5.803-3.293 5.803-1.086 0-1.9-.944-1.64-2.103.312-1.382.917-2.875.917-3.874 0-.894-.456-1.638-1.4-1.638-1.112 0-2.004 1.208-2.004 2.825 0 1.03.332 1.727.332 1.727l-1.337 5.947c-.396 1.766-.06 3.93-.031 4.148.016.129.175.16.247.063.103-.141 1.426-1.858 1.875-3.573.128-.486.731-3 .731-3 .362.723 1.416 1.36 2.537 1.36 3.34 0 5.605-3.2 5.605-7.48C13.998 3.014 11.388 0 7.424 0Z",
  fill: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconPinterest);

/***/ }),

/***/ 80242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconScreenshotsNext = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 9,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "m2 1.405 6 5-6 5",
  stroke: "#002349",
  strokeWidth: 1.6,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconScreenshotsNext);

/***/ }),

/***/ 36133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconScreenshotsPrev = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 9,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "m7 1.405-6 5 6 5",
  stroke: "#002349",
  strokeWidth: 1.6,
  strokeLinecap: "square",
  strokeLinejoin: "round"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconScreenshotsPrev);

/***/ }),

/***/ 94954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconShare = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  width: 15,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M11.515 1c-1.371 0-2.486 1.138-2.486 2.537 0 .312.06.612.161.89L5.223 7.188a2.453 2.453 0 0 0-1.738-.726C2.115 6.463 1 7.601 1 9s1.115 2.537 2.485 2.537c.677 0 1.29-.281 1.738-.732l3.967 2.763a2.58 2.58 0 0 0-.16.895c0 1.4 1.114 2.537 2.485 2.537C12.885 17 14 15.862 14 14.463s-1.115-2.536-2.485-2.536a2.48 2.48 0 0 0-2.157 1.28l-3.883-2.695a2.55 2.55 0 0 0 0-3.024l3.877-2.7a2.483 2.483 0 0 0 2.163 1.285c1.37 0 2.485-1.137 2.485-2.536C14 2.137 12.885 1 11.515 1Zm0 .39c1.164 0 2.103.958 2.103 2.147 0 1.188-.939 2.146-2.103 2.146-1.165 0-2.103-.958-2.103-2.146 0-1.189.938-2.147 2.103-2.147Zm-8.03 5.464c1.165 0 2.103.958 2.103 2.146s-.938 2.146-2.103 2.146c-1.164 0-2.103-.958-2.103-2.146s.939-2.146 2.103-2.146Zm8.03 5.463c1.164 0 2.103.958 2.103 2.146 0 1.189-.939 2.147-2.103 2.147-1.165 0-2.103-.958-2.103-2.147 0-1.188.938-2.146 2.103-2.146Z",
  fill: "currentColor",
  stroke: "currentColor"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgIconShare);

/***/ }),

/***/ 71372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ custom_HouseDetails; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/custom/HouseDetails/styles.module.scss
var styles_module = __webpack_require__(95359);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-people.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconPeople = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M11.5 4.85C11.5 7.3 10.128 9.4 8 9.4S4.5 7.3 4.5 4.85C4.5 2.4 5.2 1 8 1s3.5 1.4 3.5 3.85Z",
  stroke: "currentColor",
  strokeMiterlimit: 10
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "m10.1 8.7 4.9 2.8v1.4c0 1.162-.7 2.1-1.4 2.1H2.4c-.7 0-1.4-.938-1.4-2.1v-1.4l4.9-2.8",
  stroke: "currentColor",
  strokeMiterlimit: 10
})));

/* harmony default export */ var icon_people = (SvgIconPeople);
;// CONCATENATED MODULE: ./public/icons/icon-bedrooms.svg
var icon_bedrooms_path, icon_bedrooms_path2;

function icon_bedrooms_extends() { icon_bedrooms_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_bedrooms_extends.apply(this, arguments); }



const SvgIconBedrooms = props => /*#__PURE__*/react.createElement("svg", icon_bedrooms_extends({
  width: 21,
  height: 15,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_bedrooms_path || (icon_bedrooms_path = /*#__PURE__*/react.createElement("path", {
  d: "M20.045 3.3v11.2",
  stroke: "currentColor"
})), icon_bedrooms_path2 || (icon_bedrooms_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M.955.5v14M.955 7.033h19.09M.955 7.033v-2.8h3.404a2.8 2.8 0 0 1 2.8 2.8M.955 10.766h19.09",
  stroke: "currentColor",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_bedrooms = (SvgIconBedrooms);
// EXTERNAL MODULE: ./public/icons/icon-bathroom.svg
var icon_bathroom = __webpack_require__(4818);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
;// CONCATENATED MODULE: ./components/custom/HouseDetails/index.js






var HouseDetails = function(param) {
    var persons = param.persons, bedrooms = param.bedrooms, bathrooms = param.bathrooms, _variant = param.variant, variant = _variant === void 0 ? [] : _variant;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,withModifiers/* withModifiers */.i)("details", variant, (styles_module_default())),
        children: [
            persons && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).details__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_people, {
                        className: (styles_module_default()).details__icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).details__details,
                        children: persons
                    })
                ]
            }),
            bedrooms && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).details__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bedrooms, {
                        className: (styles_module_default()).details__icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).details__details,
                        children: bedrooms
                    })
                ]
            }),
            bathrooms && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).details__item,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_bathroom/* default */.Z, {
                        width: 24,
                        height: 15,
                        className: (styles_module_default()).details__icon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).details__details,
                        children: bathrooms
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var custom_HouseDetails = (HouseDetails);


/***/ }),

/***/ 12817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ elements_SlickSlider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/slider.js
var slider = __webpack_require__(5798);
// EXTERNAL MODULE: ./components/elements/SlickSlider/styles.module.scss
var styles_module = __webpack_require__(41227);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/icons/icon-review-prev.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgIconReviewPrev = props => /*#__PURE__*/react.createElement("svg", _extends({
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M1 9h21.84M10.167 17 1 9l9.167-8",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_review_prev = (SvgIconReviewPrev);
;// CONCATENATED MODULE: ./public/icons/icon-review-next.svg
var icon_review_next_path;

function icon_review_next_extends() { icon_review_next_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon_review_next_extends.apply(this, arguments); }



const SvgIconReviewNext = props => /*#__PURE__*/react.createElement("svg", icon_review_next_extends({
  viewBox: "0 0 24 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), icon_review_next_path || (icon_review_next_path = /*#__PURE__*/react.createElement("path", {
  d: "M23 9H1.16M13.833 17 23 9l-9.167-8",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var icon_review_next = (SvgIconReviewNext);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./providers/ResponsiveContext.js
var ResponsiveContext = __webpack_require__(40670);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./components/helpers/withModifiers.js
var withModifiers = __webpack_require__(34495);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./providers/modalProvider.js
var modalProvider = __webpack_require__(51472);
;// CONCATENATED MODULE: ./components/elements/SlickSlider/index.js

















var SlickSlider = function(_param) {
    var _pagination = _param.pagination, pagination = _pagination === void 0 ? false : _pagination, _arrows = _param.arrows, arrows = _arrows === void 0 ? true : _arrows, className = _param.className, slidesToShow = _param.slidesToShow, children = _param.children, nextArrow = _param.nextArrow, prevArrow = _param.prevArrow, _synced = _param.synced, synced = _synced === void 0 ? false : _synced, videos = _param.videos, cloudflare = _param.cloudflare, _variant = _param.variant, variant = _variant === void 0 ? [] : _variant, props = (0,_object_without_properties/* default */.Z)(_param, [
        "pagination",
        "arrows",
        "className",
        "slidesToShow",
        "children",
        "nextArrow",
        "prevArrow",
        "synced",
        "videos",
        "cloudflare",
        "variant"
    ]);
    var ref = (0,ResponsiveContext/* useResponsive */.F)(), isLargeDesktop = ref.isLargeDesktop, isSmallMobile = ref.isSmallMobile;
    var CloudflareVideo = dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 9562).then(__webpack_require__.bind(__webpack_require__, 69562));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(69562)
                ];
            }
        }
    });
    var ref1 = (0,react.useState)(), nav1 = ref1[0], setNav1 = ref1[1];
    var ref2 = (0,react.useState)(), nav2 = ref2[0], setNav2 = ref2[1];
    var ref3 = (0,react.useState)(videos && videos.map(function() {
        return false;
    })), playing = ref3[0], setPlaying = ref3[1];
    var show = (0,modalProvider/* useModalContext */.vR)().show;
    var cloudflareRefs = (0,react.useRef)(cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) ? cloudflare.map(function() {
        return (0,react.useRef)();
    }) : []);
    var iconWidth = isSmallMobile ? 17 : 22;
    // eslint-disable-next-line no-unused-vars
    var SlickButtonFix = function(_param) /*#__PURE__*/ {
        var currentSlide = _param.currentSlide, slideCount = _param.slideCount, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
            "currentSlide",
            "slideCount",
            "children"
        ]);
        return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: children
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(slider/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: classnames_default()((0,withModifiers/* withModifiers */.i)("slider", (0,_to_consumable_array/* default */.Z)(variant), (styles_module_default())), className, pagination && (styles_module_default()).withPagination),
                asNavFor: synced && nav2,
                beforeChange: function() {
                    if (playing < cloudflareRefs.current.length) {
                        var ref;
                        // Pause the video when changing slides
                        var videoElement = (ref = cloudflareRefs.current[playing]) === null || ref === void 0 ? void 0 : ref.current;
                        if (videoElement) {
                            videoElement.pause();
                        }
                    }
                    setPlaying(false);
                },
                ref: function(slider1) {
                    return synced && setNav1(slider1);
                },
                slidesToShow: slidesToShow || 3,
                dots: pagination,
                arrows: arrows,
                pagination: pagination && {
                    clickable: true
                },
                nextArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickButtonFix, {
                    children: nextArrow || /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_review_next, {
                        width: iconWidth
                    })
                }),
                prevArrow: /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickButtonFix, {
                    children: prevArrow || /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_review_prev, {
                        width: iconWidth
                    })
                })
            }, props), {
                children: [
                    show && cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) && cloudflare.map(function(video, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudflareVideo, {
                            playing: show && playing[index],
                            reference: cloudflareRefs.current[index],
                            controls: true,
                            src: video,
                            onPlay: function() {
                                return setPlaying(index);
                            },
                            onPause: function() {
                                return setPlaying(false);
                            },
                            onEnded: function() {
                                return setPlaying(false);
                            }
                        }, "video-".concat(video));
                    }),
                    children.length === 1 ? children : children.map(function(item) {
                        return item;
                    })
                ]
            })),
            synced && /*#__PURE__*/ (0,jsx_runtime.jsxs)(slider/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (styles_module_default()).slider__secondary,
                asNavFor: synced && nav1,
                ref: function(slider2) {
                    return synced && setNav2(slider2);
                },
                arrows: false,
                slidesToShow: isSmallMobile ? 3 : isLargeDesktop ? 4 : 6,
                autoplay: false,
                focusOnSelect: true,
                accessibility: false,
                focusOnChange: false
            }, props), {
                children: [
                    cloudflare && !(0,isEmpty/* default */.Z)(cloudflare) && cloudflare.map(function(_item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            // eslint-disable-next-line no-undef
                            src: "https://customer-".concat("mwbbzmyggbfuda1b", ".cloudflarestream.com/").concat(_item, "/thumbnails/thumbnail.jpg")
                        }, _item);
                    }),
                    children.length === 1 ? children : children.map(function(item) {
                        return item;
                    })
                ]
            }))
        ]
    });
};
/* harmony default export */ var elements_SlickSlider = (SlickSlider);


/***/ }),

/***/ 29828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ withComma; }
/* harmony export */ });
// function that adds comma to the prices
var withComma = function(x) {
    if (x < 1) {
        return x;
    }
    if (x > 1000) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return x;
};


/***/ }),

/***/ 89149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eu": function() { return /* binding */ useAuthContext; },
/* harmony export */   "HD": function() { return /* binding */ AuthContextProvider; }
/* harmony export */ });
/* unused harmony export AuthContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



var AuthContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useAuthContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(AuthContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var AuthContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), loggedIn = ref[0], setLoggedIn = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isAgent = ref1[0], seIsAgent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), user = ref2[0], setUser = ref2[1];
    var isAuthorized = loggedIn && isAgent;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // When storage changes refetch
        setLoggedIn(localStorage.getItem("access_token") || false);
        seIsAgent(localStorage.getItem("isAgent") || false);
        setUser(localStorage.getItem("user") || false);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AuthContext.Provider, {
        value: {
            loggedIn: loggedIn,
            setLoggedIn: setLoggedIn,
            isAgent: isAgent,
            seIsAgent: seIsAgent,
            isAuthorized: isAuthorized,
            user: user,
            setUser: setUser
        },
        children: children
    });
};



/***/ }),

/***/ 83155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H2": function() { return /* binding */ useFavouritesContext; },
/* harmony export */   "td": function() { return /* binding */ FavouritesContextProvider; }
/* harmony export */ });
/* unused harmony export FavouritesContext */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35242);
/* harmony import */ var _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92375);
/* harmony import */ var _authProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89149);






var safeLocalStorage = {
    getItem: function(key) {
        try {
            return  true ? localStorage.getItem(key) : 0;
        } catch (e) {
            return null;
        }
    },
    setItem: function(key, value) {
        try {
            if (true) {
                localStorage.setItem(key, value);
            }
        } catch (e) {
        // localStorage not available (e.g., Safari private browsing)
        }
    }
};
var FavouritesContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useFavouritesContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(FavouritesContext);
    if (context === undefined) {
        throw new Error("useFavouritesContext was used outside of its Provider");
    }
    return context;
};
var FavouritesContextProvider = function(param) {
    var children = param.children;
    var isFavourite = function isFavourite(value) {
        return favourites.includes(value);
    };
    var addOrRemoveFavourite = function addOrRemoveFavourite(value) {
        var newFavourites = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(favourites);
        if (isFavourite(value)) {
            (0,lodash_es_pull__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(newFavourites, value);
        } else {
            newFavourites.push(value);
        }
        setFavourites(newFavourites);
        safeLocalStorage.setItem("favourites", newFavourites.join(","));
        if (loggedIn) {
            _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("user/favourites/update", {
                user_id: user,
                favourites: newFavourites
            }).catch(function(err) {
                return console.error(err);
            });
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), favourites = ref[0], setFavourites = ref[1];
    var ref1 = (0,_authProvider__WEBPACK_IMPORTED_MODULE_3__/* .useAuthContext */ .Eu)(), user = ref1.user, loggedIn = ref1.loggedIn;
    var hasInitializedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // Load favourites from localStorage on initial client-side mount
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var storedFavourites = safeLocalStorage.getItem("favourites");
        if (storedFavourites && storedFavourites !== "") {
            setFavourites(storedFavourites.split(",").filter(Boolean));
        }
        hasInitializedRef.current = true;
    }, []);
    // Sync with database when user logs in
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!loggedIn || !hasInitializedRef.current) {
            return;
        }
        // Get current local favourites before async operation
        var localFavourites = safeLocalStorage.getItem("favourites");
        var localIds = localFavourites ? localFavourites.split(",").filter(Boolean) : [];
        _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("user/".concat(user, "/favourites")).then(function(res) {
            var dbFavourites = Array.isArray(res.data.favourites) ? res.data.favourites : [];
            // Merge local and DB favourites (union of both)
            var merged = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(localIds).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(dbFavourites))));
            setFavourites(merged);
            safeLocalStorage.setItem("favourites", merged.join(","));
            // Save merged result back to DB if there were local additions
            if (localIds.length > 0 && merged.length > dbFavourites.length) {
                _components_configs_axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].post */ .Z.post("user/favourites/update", {
                    user_id: user,
                    favourites: merged
                }).catch(function(err) {
                    return console.error(err);
                });
            }
        }).catch(function(err) {
            return console.error(err);
        });
    }, [
        loggedIn,
        user
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FavouritesContext.Provider, {
        value: {
            favourites: favourites,
            isFavourite: isFavourite,
            addOrRemoveFavourite: addOrRemoveFavourite
        },
        children: children
    });
};



/***/ }),

/***/ 51472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ny": function() { return /* binding */ ModalContextProvider; },
/* harmony export */   "vR": function() { return /* binding */ useModalContext; }
/* harmony export */ });
/* unused harmony export ModalContext */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var ModalContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)("default");
var useModalContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(ModalContext);
    if (context === undefined) {
        throw new Error("useModalContext was used outside of its Provider");
    }
    return context;
};
var ModalContextProvider = function(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), show = ref[0], setShow = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), content = ref1[0], setContent = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), variant = ref2[0], setVariant = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), beforeClose = ref3[0], handleBeforeClose = ref3[1];
    var body =  true && document.querySelector("body");
    var handleShowModal = function() {
        setShow(true);
        body.classList.add("modal-open");
    };
    var handleCloseModal = function() {
        setShow(false);
        body.classList.remove("modal-open");
        // Clear content to reset state when modal closes
        // This ensures errors and form state are cleared for next opening
        setContent(false);
        setVariant([]);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (show) {
            beforeClose && beforeClose();
            handleCloseModal();
        }
    }, [
        router.pathname
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalContext.Provider, {
        value: {
            handleShowModal: handleShowModal,
            handleCloseModal: handleCloseModal,
            handleBeforeClose: handleBeforeClose,
            setContent: setContent,
            content: content,
            setVariant: setVariant,
            show: show,
            variant: variant
        },
        children: children
    });
};



/***/ }),

/***/ 95359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"details":"styles_details__v1cty","details__item":"styles_details__item__NSFUQ","details__details":"styles_details__details__ZtG_e","details__icon":"styles_details__icon__AmD8a","details--close":"styles_details--close__Qwe3F"};

/***/ }),

/***/ 41227:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"styles_slider__jV0qF","slider__video":"styles_slider__video__6PYe8","withPagination":"styles_withPagination__IJC8S","slider__secondary":"styles_slider__secondary__iaEjw","slider--white":"styles_slider--white__qLIzX","slider--arrow-auto":"styles_slider--arrow-auto__ze_w3"};

/***/ })

}]);